import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex w-full min-w-0 rounded-md border border-border bg-card px-3.5 py-2.5 text-sm shadow-none transition-all duration-200 outline-none",
        "placeholder:text-muted-foreground",
        "hover:border-muted-foreground/30",
        "focus:border focus:ring-2 focus:ring-muted-foreground/50 focus:outline-none",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "resize-none",
        "caret-primary",
        className
      )}

      {...props}
    />
  )
}

export { Textarea }
